import { atom, useAtomValue } from 'jotai';

export type Branding = 'hero' | 'chatoshi';

export const brandingPreviewAtom = atom<Branding | null>(null);

// Preview branding affects presentation only, not API/auth configuration.
export function useBranding() {
  const preview = useAtomValue(brandingPreviewAtom);
  return (import.meta.env.DEV && preview) || window.__CONFIG.VITE_BRANDING;
}
